<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getBankClaimInfoHeaders ()"
    :items="getBankClaimItems ()"
    hide-actions
  >
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
      />
    </template>
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.DebtorName }} ehf (kt. {{ props.item.DebtorId | kennitala }})</td>
      <td class="text-xs-left">{{ props.item.Account | account }}</td>
      <td class="text-xs-left">{{ props.item.Amount | amount }}</td>
      <td class="text-xs-left">{{ props.item.DueDate | date }}</td>
      <td class="text-xs-left">{{ props.item.FinalDueDate | date }}</td>
      <td class="text-xs-left">{{ props.item.Status }}</td>
    </template>
  </v-data-table>
</template>

<script>
    import DataGridSort from '../controllers/DataGridSort'
    import EnumIterator from '../helper/EnumIterator'
    export default {
        name: "BamkClaimInfoDatagrid",
        components: {DataGridSort},
        props: ['bankClaim'],
        data ()
        {
            return {
                pagination:
                    {
                        sortBy: 'id'
                    }
            }
        },
        methods:{
            getBankClaimInfoHeaders ()
            {
                return [
                    {sortable: false, text: this.$t('krita.common.debtor'), value: 'debtor', align: 'left'},
                    {sortable: false, text: this.$t('krita.common.account'), value: 'account', align: 'left'},
                    {sortable: false, text: this.$t('krita.common.capital'), value: 'capital', align: 'left'},
                    {sortable: false, text: this.$t('krita.common.dueDate'), value: 'dueDate', align: 'left'},
                    {sortable: false, text: this.$t('krita.common.finalDueDate'), value: 'finalDueDate', align: 'left'},
                    {sortable: false, text: this.$t('krita.common.status'), value: 'status', align: 'left'},
                ]
            },
            getBankClaimItems ()
            {
              let self = this;

                return [
                    {
                        DebtorId: self.bankClaim.DebtorId,
                        DebtorName: self.bankClaim.DebtorName,
                        Account: self.bankClaim.Account,
                        Amount: self.bankClaim.Amount,
                        DueDate: self.bankClaim.DueDate,
                        FinalDueDate: self.bankClaim.FinalDueDate,
                        Status: self.$t(EnumIterator.processBankClaimStatus(self.bankClaim.Status)),
                    }
                ]

            }
        }
    }
</script>

<style scoped>

</style>